import React, { useEffect, useState } from "react";
import PageHeading from "../../../../components/common/PageHeading";
import { Form, Input, Space, Button, Card, Spin } from "antd";
import FormAction from "../../../../components/common/FormAction";
import ActionsLog from "../../../../components/common/ActionsLog";
import { logs } from "../../../../data/actionsLog";
import InquiriesReceived from "./Components/InquiriesReceived/InquiriesReceived";
import Showings from "./Components/Showings";
import Interests from "./Components/Interests";
import Profile from "./Components/Profile";
import Notes from "../../../../components/common/Notes";
import Texts from "../../../../components/common/Texts";
import Emails from "../../../../components/common/Emails";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import EmailRentalApplication from "../../../../components/common/EmailRentalApplication";
import ConfirmationBox from "../../../../components/common/ConfirmationBox";
import TextArea from "antd/es/input/TextArea";
import MultiSelect from "../../../../components/common/MultiSelect";
import { useAuthState } from "react-firebase-hooks/auth";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { auth, db } from "../../../../firebase";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

function GuestCardItem() {
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [emailSendBoxOpen, setEmailSendBoxOpen] = useState(false);
  const [guestCardData, setGuestCardData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const rightBarData = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "New Guest Card",
        "1",
        "",
        "",
        "/leasing/guest-cards/new-guest-card"
      ),
      RightBarMethod("Record Communication", "2", "", "", ""),
      RightBarMethod(
        <span onClick={() => setEmailSendBoxOpen(true)}>Send Email</span>,
        "3",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={() => setIsConfirmationBoxOpen(true)}>
          Email Rental Application
        </span>,
        "4",
        "",
        "",
        ""
      ),
      RightBarMethod("Enter Rental Application", "5", "", "", ""),
    ]),

    RightBarMethod(
      " HELP TOPICS",
      "t4",
      <i className="fa-solid fa-circle-question"></i>,
      [
        RightBarMethod("Using Guest Cards", "13", "", "", "/"),
        RightBarMethod("Premium Leads", "14", "", "", "/"),
        RightBarMethod("Scheduling Showings", "14", "", "", "/"),
        RightBarMethod("Virtual Showings", "14", "", "", "/"),
        RightBarMethod("Record Communication", "14", "", "", "/"),
      ]
    ),
  ];

  const { id } = useParams();

  const [showEditContactInfo, setShowEditContactInfo] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [user, loading] = useAuthState(auth);
  const [isWait, setIsWait] = useState(false);
  const [notes, setNotes] = useState([]);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setCompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onFinish = async (values) => {
    setIsWait(true);
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    const guestContact = {
      guestContact: {
        assignTo: "",
        firstName: values.firstName,
        middleInitial: values.middleInitial,
        lastName: values.lastName,
        phoneNumber: values.phoneNumber,
        email: values.email,
        source: "",
      },
    };

    console.log("guestContact", guestContact);

    const guestCardRef = doc(db, "companies", companyName, "guestCards", id);
    try {
      await updateDoc(guestCardRef, guestContact); // Asynchronous operation wrapped in try-catch
      setIsWait(true);
      setShowEditContactInfo(!showEditContactInfo);
      toast.success("Updated Successfully!");
      console.log("Successfully updated guest contact"); // Success log
    } catch (error) {
      setIsWait(false);

      console.error("Error updating guest contact:", error); // Log any potential errors
    }
  };

  const onFinishFailed = (err) => {
    toast.error("Fields Required");
    console.log("error while updating", err);
  };

  const [defaultValues, setDefaultValues] = useState({});

  const getData = async () => {
    setIsLoading(true);
    if (companyName) {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const guestCardDocRef = doc(companyDocRef, "guestCards", id);

      // Retrieve the rental application document by its document ID
      getDoc(guestCardDocRef)
        .then((docSnapshot) => {
          if (docSnapshot.exists()) {
            // Document exists; you can access its data
            const data = docSnapshot.data();
            console.log("Guest Cards Application Data:", data);
            setGuestCardData(data);
            const initValues = {
              firstName: data.guestContact?.firstName,
              middleInitial: data.guestContact?.middleInitial,
              lastName: data.guestContact?.lastName,
              phoneNumber: data.guestContact?.phoneNumber,
              email: data.guestContact?.email,
            };
            setDefaultValues(initValues);
            form.setFieldsValue(initValues);
            setIsLoading(false);
          } else {
            console.log("Guest Cards Application not found");
          }
        })
        .catch((error) => {
          console.error("Error fetching Guest Cards application:", error);
        });
    }
  };

  useEffect(() => {
    if (companyName) {
      getData();
    }
  }, [companyName, isWait]);

  const [form] = Form.useForm(); // Add this line inside your component function

  form.setFieldsValue(defaultValues);

  const handleEditBtn = () => {
    setShowEditContactInfo(!showEditContactInfo);
    setIsWait(false);
  };
  return (
    <>
      {isLoading ? (
        <div className="spin-container">
          <Spin tip="Loading..." />
        </div>
      ) : (
        <>
          <PageHeading heading="Guest Card" />

          <Card
            title={
              showEditContactInfo
                ? `${guestCardData?.guestContact?.firstName} ${guestCardData?.guestContact?.lastName}`
                : "Contact Information"
            }
            bordered={false}
            extra={
              showEditContactInfo ? (
                <Button
                  type="link"
                  onClick={handleEditBtn}
                  style={{ paddingRight: 0 }}
                >
                  Edit
                </Button>
              ) : (
                <></>
              )
            }
          >
            {!showEditContactInfo ? (
              <Form
                name="control-hooks"
                labelCol={{ span: 7 }}
                className="form-container"
                initialValues={defaultValues}
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
              >
                <Form.Item
                  name="firstName"
                  label="First Name"
                  wrapperCol={{ span: 8 }}
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name="middleInitial"
                  label="Middle Initial"
                  wrapperCol={{ span: 8 }}
                >
                  <Input style={{ width: 50 }} />
                </Form.Item>

                <Form.Item
                  name="lastName"
                  label="Last Name"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>

                <Form.Item name="email" label="Email" wrapperCol={{ span: 8 }}>
                  <Input />
                </Form.Item>

                <Form.Item
                  name="phoneNumber"
                  label="Phone Number"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>
                <br />
                <FormAction
                  cancel={handleEditBtn}
                  submit="submit"
                  loading={isWait}
                />
              </Form>
            ) : (
              <></>
            )}
            {showEditContactInfo && guestCardData ? (
              <>
                <Form
                  labelCol={{ span: 7 }}
                  autoComplete="off"
                  className="form-container"
                  colon={false}
                >
                  <Form.Item label="Email:" wrapperCol={{ span: 8 }}>
                    <Button type="link">
                      {guestCardData?.guestContact?.email
                        ? guestCardData?.guestContact?.email
                        : "--"}
                    </Button>
                  </Form.Item>

                  <Form.Item label="Phone:" wrapperCol={{ span: 8 }}>
                    <Space>
                      <Button type="link">
                        {guestCardData?.guestContact?.phoneNumber
                          ? guestCardData?.guestContact?.phoneNumber
                          : "--"}
                      </Button>
                      <Button
                        className="headerButtons"
                        size="small"
                        icon={<i className="fa-sharp fa-solid fa-comment"> </i>}
                      >
                        {" "}
                        Text
                      </Button>
                    </Space>
                  </Form.Item>
                </Form>
              </>
            ) : (
              <></>
            )}
          </Card>

          {/* <br /> 

  <ActionsLog data={logs} />

  <br />

  <InquiriesReceived />

  <br />

  <Showings />
<br />

  {guestCardData && (
    <Interests
      data={guestCardData?.interests}
      id={id}
      companyName={companyName}
      setIsWait={setIsWait}
    />
  )} */}

          <br />

          {guestCardData && (
            <Profile
              id={id}
              companyName={companyName}
              data={guestCardData?.profile}
              setIsWait={setIsWait}
              isWait={isWait}
            />
          )}

          <br />

          {companyName ? (
            <Notes
              notesForCollection="guestCards"
              notesForCollectionId={id}
              companyName={companyName}
              notes={notes}
              setNotes={setNotes}
            />
          ) : null}
          {/* <br /> */}
          {/* <Texts /> */}
          {/* <br />
  <Emails /> */}
          <br />
          {companyName ? (
            <AttachmentsUpload
              id={id}
              data={guestCardData?.attachments}
              companyName={companyName}
              collection="guestCards"
            />
          ) : null}

          <div className="RightSidebar">
            <RightBar RightBarData={rightBarData} />
          </div>
          {isConfirmationBoxOpen ? (
            <EmailRentalApplication
              isConfirmationBoxOpen={isConfirmationBoxOpen}
              setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}
            />
          ) : null}
          {emailSendBoxOpen ? (
            <ConfirmationBox setIsConfirmationBoxOpen={setEmailSendBoxOpen}>
              <h2>Send Email</h2>
              <Form layout="vertical">
                <Form.Item
                  label="Recipients"
                  required
                  extra={
                    <span className="onclick-text">Copy Email Addresses</span>
                  }
                >
                  <Input placeholder="Jessica William" />
                </Form.Item>
                <Form.Item label="CC">
                  <MultiSelect options={["test 1", "test 2", "test 3"]} />
                </Form.Item>
                <Form.Item label="BCC">
                  <MultiSelect options={["test 1", "test 2", "test 3"]} />
                </Form.Item>
                <Form.Item label="Subject" required>
                  <Input placeholder="Enter subject" />
                </Form.Item>
                <Form.Item label="Message" required>
                  <TextArea placeholder="Enter message" rows={8} />
                </Form.Item>
              </Form>
              <div className="action-buttons">
                <button
                  className="blue"
                  onClick={() => setEmailSendBoxOpen(false)}
                >
                  Send
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => setEmailSendBoxOpen(false)}
                >
                  Cancel
                </button>
                <span className="onclick-text">Customize My Signature</span>
              </div>
            </ConfirmationBox>
          ) : null}
        </>
      )}
    </>
  );
}

export default GuestCardItem;
